import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Wizard from '../../components/Wizard';
import { usePageContent } from '../../hooks/usePageContent';
import './index.module.css';

const GiftCardSuccessPage = () => {
  const navigate = useNavigate();
  const { find } = usePageContent('gift-success');
  const wizardContent = find('wizard') || {};
  const c = find('successMessage') || {};
  const wizardSteps = wizardContent.steps || [
    { title: 'Personalise voucher' },
    { title: 'Confirm delivery details' },
    { title: 'Checkout' },
  ];
  const [paymentData, setPaymentData] = useState(null);
  const [giftData, setGiftData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedPayment = sessionStorage.getItem('giftPaymentReceipt');
    const storedGift = sessionStorage.getItem('giftOrderData');

    if (!storedPayment || !storedGift) {
      navigate('/gift-vouchers');
    } else {
      setPaymentData(JSON.parse(storedPayment));
      setGiftData(JSON.parse(storedGift));
      sessionStorage.removeItem('giftPaymentReceipt');
      sessionStorage.removeItem('giftOrderData');
      sessionStorage.removeItem('giftCardDetails');
      setLoading(false);
    }
  }, [navigate]);

  const handleBuyAnother = () => {
    sessionStorage.removeItem('giftOrderData');
    sessionStorage.removeItem('giftPaymentReceipt');
    sessionStorage.removeItem('giftCardDetails');
    navigate('/gift-vouchers/personalise-voucher');
  };

  if (loading || !giftData || !paymentData) {
    return (
      <div id="content">
        <div className="row">
          <div className="plate-wizard">
            <div className="loading__panel" role="alert">{c.loadingText || 'Loading...'}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="content">
      <div className="row">
        <div className="page-header">
          <div className="page-header__content">
            <h1 className="page-header__title">{c.pageTitle || 'Gift vouchers'}</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="plate-wizard">
          <Wizard steps={wizardSteps} currentStep={3} />

          <div className="plate-wizard__form plate-wizard__form--success">
            <div className="plate-wizard__form-header">
              <h2 className="plate-wizard__form-title" tabIndex="-1" style={{ textAlign: 'center' }}>
                {c.sectionTitle || 'Payment successful'}
              </h2>
            </div>

            <div>
              <div className="success-message">
                <div className="success-message__inner">
                  <div className="success-message__content">
                    {paymentData.orderNumber && (
                      <dl className="success-message__data">
                        <dt className="success-message__data-title">{c.orderNumberLabel || 'Order number:'}</dt>
                        <dd className="success-message__data-value">{paymentData.orderNumber}</dd>
                      </dl>
                    )}

                    <div className="rich-text">
                      <p>
                        {c.thankYouText || 'Thank you for purchasing a VicRoads Custom Plates gift voucher!'}
                        {' '}
                        {c.voucherSentText || 'Your voucher will be sent to'}
                        {' '}
                        {giftData.sendTo === 'recipient' && giftData.recipient?.email
                          ? giftData.recipient.email
                          : giftData.sender?.email}.
                      </p>
                      <p>
                        {c.emailSupportText || "If you don't receive your voucher within 10 business days, please check your junk mail or contact"}{' '}
                        <a href={`mailto:${c.emailSupportAddress || 'custom.plates@roads.vic.gov.au'}`}>
                          {c.emailSupportAddress || 'custom.plates@roads.vic.gov.au'}
                        </a>{' '}
                        or {c.emailSupportPhone || '1300 660 417'} ({c.emailSupportHours || 'between 8:30am – 5:00pm Monday to Friday'}).
                      </p>
                    </div>

                    <div className="success-message__actions">
                      <button className="button button--full-width" onClick={handleBuyAnother}>
                        <span className="button__text">{c.buyAnotherText || 'Buy another'}</span>
                      </button>
                      <Link to="/" className="button button--full-width button--secondary">
                        <span className="button__text">{c.returnHomeText || 'Return to home'}</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardSuccessPage;
